// The icon for each user type, as FontAwesome names (the whole set is registered in app.js).
// Every place that shows a user's type as an icon reads it from here.
export const USER_TYPE_ICONS = {
  Student: "user",
  Teacher: "graduation-cap",
  Admin: "user-shield",
  Superuser: "user-gear",
  AplSupervisor: "hammer",
  Analytics: "chart-line",
};
